// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'http://sriapi.somee.com/',
};

//'http://localhost:59355/'

// 'http://sriapi.somee.com/'

//'http://ec2-52-200-8-246.compute-1.amazonaws.com/'

// 'http://13.221.106.65:80/', // aws server

// https://gdeac3io77.execute-api.us-east-1.amazonaws.com/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
